import { render, staticRenderFns } from "./GoogleAds.vue?vue&type=template&id=31e26a56&scoped=true&"
import script from "./GoogleAds.vue?vue&type=script&lang=js&"
export * from "./GoogleAds.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAds.vue?vue&type=style&index=0&id=31e26a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e26a56",
  null
  
)

export default component.exports